import { Injectable, NgZone} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomService {

  findBrowser()
  {
    var c_document:any=document;
    var documentMode=c_document.documentMode;
    var c_window:any=window;

    var isSafari = Object.prototype.toString.call(c_window.HTMLElement).indexOf('Constructor') > 0;
    var isEdge = navigator.userAgent.indexOf(' Edge/') >= 0 || navigator.userAgent.indexOf(' edge/') >= 0;
    var isIExplorer = (/*@cc_on!@*/false || !!documentMode); // At least IE6
    if(isSafari)
    {
      return "Safari";
    }
    else if(isEdge)
    {
      return "Edge";
    }
    else if(isIExplorer)
    {
      return "IE";
    }
    else
    {
      return "";
    }
  }

  getDeviceInfo()
  {
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    var c_document:any=document;
    var documentMode=c_document.documentMode;

    var isIE = (/*@cc_on!@*/false || !!documentMode);
    var isEdge = window.navigator.userAgent.indexOf("Edge") > -1;

    if(android_dev)
    {
    return "Android";
    }
    else if(isIOS)
    {
    return "IOS";
    }
    else if(isIE)
    {
    return "IE";
    }
    else if(isEdge)
    {
    return "Edge";
    }
    else
    {
    return "";
    }

  }


   isiPhone() {
      if (navigator.platform.indexOf("iPhone") != -1)
          return 'iphone';
      if (navigator.platform.indexOf("iPod") != -1)
          return 'ipod';
      if (navigator.platform.indexOf("iPad") != -1)
          return 'ipad';
  }


  elHasClass(el, className) {
    let flag = false;    
    if (el.classList) {
      flag= (el.classList.indexOf(className) != -1);
    }
    return flag;
  }

  elAddClass(el, className) {
    if (el.classList)
      el.classList.add(className)
    else if (!this.elHasClass(el, className)) el.className += " " + className
  }

  elremoveClass(el, className) {
    if (el.classList)
      el.classList.remove(className)
    else if (this.elHasClass(el, className)) {
      var reg = new RegExp('(\\s|^)' + className + '(\\s|$)')
      el.className=el.className.replace(reg, ' ')
    }
  }


  addClass(tag,className)
  {

    let classindex = tag.indexOf(".");
    let idindex = tag.indexOf("#");

    if(classindex!=-1)
    {
      tag=tag.replace(".", "");
      let classList: any = document.getElementsByClassName(tag);
      let c_len=classList.length;
      for (let index = 0; index < c_len; index++) {
        let element = classList[index];
        this.elAddClass(element, className) ;
      }
    }
    else if(idindex!=-1)
    {
      tag=tag.replace("#", "");
      let singleId: any = document.getElementById(tag);
      this.elAddClass(singleId, className);
    }
    else //tag name based
    {
      let singleTag: any = document.getElementsByTagName(tag)[0];
      this.elAddClass(singleTag, className) ;
    }  
  }

  removeClass(tag,className)
  {

    let classindex = tag.indexOf(".");
    let idindex = tag.indexOf("#");

    if(classindex!=-1)
    {
      tag=tag.replace(".", "");
      let classList: any = document.getElementsByClassName(tag);
      let c_len=classList.length;
      for (let index = 0; index < c_len; index++) {
        let element = classList[index];
        this.elremoveClass(element, className) ;
      }
    }
    else if(idindex!=-1)
    {
      tag=tag.replace("#", "");
      let singleId: any = document.getElementById(tag);
      if(singleId && singleId!="")
      {
        this.elremoveClass(singleId, className);
      }
    }
    else //tag name based
    {
      let singleTag: any = document.getElementsByTagName(tag)[0];
      if(singleTag && singleTag!="")
      {
        this.elremoveClass(singleTag, className) ;
      }
    }

  

  }

  toggleClass(tag, className) {
    let classindex = tag.indexOf(".");
    let idindex = tag.indexOf("#");

    if (classindex != -1) {
      tag = tag.replace(".", "");
      let classList: any = document.getElementsByClassName(tag);
      let c_len = classList.length;
      for (let index = 0; index < c_len; index++) {
        let element = classList[index];

        var hasFlag = this.elHasClass(element, className);
        if (hasFlag) {
          this.elremoveClass(element, className);
        }
        else {
          this.elAddClass(element, className);
        }
      }
    }
    else if (idindex != -1) {
      tag = tag.replace("#", "");
      let singleId: any = document.getElementById(tag);

      var hasFlag = this.elHasClass(singleId, className);
      if (hasFlag) {
        this.elremoveClass(singleId, className);
      }
      else {
        this.elAddClass(singleId, className);
      }
    }
    else //tag name based
    {
      let singleTag: any = document.getElementsByTagName(tag)[0];

      var hasFlag = this.elHasClass(singleTag, className);
      if (hasFlag) {
        this.elremoveClass(singleTag, className);
      }
      else {
        this.elAddClass(singleTag, className);
      }
    }
  }


  clickToggleClass(element, className) {
    var hasFlag = this.elHasClass(element, className);
    if (hasFlag) {
      this.elremoveClass(element, className);
    }
    else {
      this.elAddClass(element, className);
    }
    console.log(hasFlag);
  }

  elAddAttribute(el, attrName,attrValue)
  {
    el.setAttribute(attrName,attrValue);
  }

  setAttribute(tag,attrName,attrValue)
  {
    let classindex = tag.indexOf(".");
    let idindex = tag.indexOf("#");

    if(classindex!=-1)
    {
      tag=tag.replace(".", "");
      let classList: any = document.getElementsByClassName(tag);
      let c_len=classList.length;
      for (let index = 0; index < c_len; index++) {
        let element = classList[index];
        this.elAddAttribute(element, attrName,attrValue) ;
      }
    }
    else if(idindex!=-1)
    {
      tag=tag.replace("#", "");
      let singleId: any = document.getElementById(tag);
      this.elAddAttribute(singleId, attrName,attrValue) ;
    }
    else //tag name based
    {
      let singleTag: any = document.getElementsByTagName(tag)[0];
      this.elAddAttribute(singleTag, attrName,attrValue) ;
    }

  }

  removeAttribute(tag,attrName)
  {
    this.setAttribute(tag,attrName,"");
  }

}
